import { render, staticRenderFns } from "./SalesTrendPage.vue?vue&type=template&id=4cb4806e&"
import script from "./SalesTrendPage.vue?vue&type=script&lang=js&"
export * from "./SalesTrendPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports